import { LazyMotion } from 'motion/react';
import type { ReactNode } from 'react';

// ----------------------------------------------------------------------

const loadFeatures = () => import('./features.js').then((res) => res.default);

type Props = {
  children: ReactNode;
};

export default function MotionLazyContainer({ children }: Props) {
  return (
    <LazyMotion strict features={loadFeatures}>
      {children}
    </LazyMotion>
  );
}
